import { help } from './he/help'
import { externalAccess } from './he/externalAccess'
import { cashRegisters } from './he/cashRegisters'
import {patientTitleSheet} from './he/patientTitleSheet'
import { clinicalSummary } from './he/clinicalSummary'
import { anamnesis } from './he/anamnesis'
import { legalEntities } from './he/legalEntities'
import type { Messages } from './catalogue.en'
import { clinical } from './he/clinical'
import { clinicalTranslation } from './he/clinicalTranslation'
import { common } from './he/common'
import { controlCenter } from './he/controlCenter'
import { controlCenterAccess } from './he/controlCenterAccess'
import { controlCenterConnectors } from './he/controlCenterConnectors'
import { controlCenterIntegrations } from './he/controlCenterIntegrations'
import { controlCenterModules } from './he/controlCenterModules'
import { correspondence } from './he/correspondence'
import { dashboard } from './he/dashboard'
import { emr } from './he/emr'
import { externalEntry } from './he/externalEntry'
import { egisz } from './he/egisz'
import { externalModules } from './he/externalModules'
import { finance } from './he/finance'
import { financeSettlement } from './he/financeSettlement'
import { financePrepaid } from './he/financePrepaid'
import { priceCatalog } from './he/priceCatalog'
import { imaging } from './he/imaging'
import { laboratory } from './he/laboratory'
import { laboratoryRecognition } from './he/laboratoryRecognition'
import { laboratoryReview } from './he/laboratoryReview'
import { localizedField } from './he/localizedField'
import { leads } from './he/leads'
import { notifications } from './he/notifications'
import { patients } from './he/patients'
import { persons } from './he/persons'
import { schedule } from './he/schedule'
import { scheduleWaiting } from './he/scheduleWaiting'
import { scheduleReception } from './he/scheduleReception'
import { tasks } from './he/tasks'
import { processing } from './he/processing'
import { tracker } from './he/tracker'
import { estimates } from './he/estimates'

/**
 * initial application Hebrew catalogue. It is typed `Partial<Messages>` on purpose: the fallback
 * to English has to be a real, exercised code path rather than a claim, and a
 * later locale added mid-slice must degrade to English instead of failing to
 * build. Completeness for the initial application surface is enforced by `catalogue.test.ts`,
 * which asserts this key set equals the English one.
 *
 * That `Partial` is why each surface module is also `Partial<Messages>` rather
 * than exhaustive over its English counterpart. Making Hebrew complete at
 * compile time would be stricter, and it would delete the property this design
 * exists for: a locale that falls behind mid-slice must degrade to English
 * rather than fail to build.
 *
 * The surfaces mirror the English ones exactly, and
 * `catalogue.modules.test.ts` fails naming the surface if they ever diverge.
 */
export const HE_SURFACES = {
  externalAccess,
  help,
  cashRegisters,
  common,
  schedule,
  scheduleWaiting,
  scheduleReception,
  patients,
  patientTitleSheet,
  clinicalSummary,
  anamnesis,
  persons,
  emr,
  externalEntry,
  finance,
  financeSettlement,
  financePrepaid,
  priceCatalog,
  imaging,
  clinical,
  clinicalTranslation,
  laboratory,
  laboratoryRecognition,
  laboratoryReview,
  localizedField,
  legalEntities,
  leads,
  tasks,
  processing,
  notifications,
  dashboard,
  controlCenter,
  controlCenterAccess,
  controlCenterConnectors,
  controlCenterIntegrations,
  controlCenterModules,
  correspondence,
  tracker,
  estimates,
  externalModules,
  egisz,
} as const

export const he: Partial<Messages> = {
  ...externalAccess,
  ...help,
  ...common,
  ...schedule,
  ...scheduleWaiting,
  ...scheduleReception,
  ...patients,
  ...patientTitleSheet,
  ...clinicalSummary,
  ...anamnesis,
  ...persons,
  ...emr,
  ...externalEntry,
  ...finance,
  ...cashRegisters,
  ...financeSettlement,
  ...financePrepaid,
  ...priceCatalog,
  ...imaging,
  ...clinical,
  ...clinicalTranslation,
  ...laboratory,
  ...laboratoryRecognition,
  ...laboratoryReview,
  ...localizedField,
  ...legalEntities,
  ...leads,
  ...tasks,
  ...processing,
  ...notifications,
  ...dashboard,
  ...controlCenter,
  ...controlCenterAccess,
  ...controlCenterConnectors,
  ...controlCenterIntegrations,
  ...controlCenterModules,
  ...correspondence,
  ...tracker,
  ...estimates,
  ...externalModules,
  ...egisz,
}
